export interface MarketCategory {
  category: string
  players: string[]
  descriptor: string
}

/** Neutral, category-level positioning — no capability claims about any player. */
export const marketCategories: MarketCategory[] = [
  {
    category: 'Native call screening',
    players: ['Apple', 'Samsung'],
    descriptor: 'Device-level call screening & assistance',
  },
  {
    category: 'Consumer call management',
    players: ['YouMail'],
    descriptor: 'Voicemail, call management & screening',
  },
  {
    category: 'AI voice infrastructure',
    players: ['ElevenLabs', 'Vapi', 'Retell AI', 'Bland AI'],
    descriptor: 'Voice models, APIs & programmable AI agents',
  },
  {
    category: 'Business communications',
    players: ['Dialpad', 'RingCentral', 'Quo / OpenPhone', 'Smith.ai'],
    descriptor: 'Business calling, contact centre & AI reception',
  },
]

export const vexuSpan = [
  'Consumer AI',
  'Telecom',
  'Voice AI',
  'Business AI',
  'Workflows & actions',
]

export const vexuDifferentiators = [
  {
    title: 'Existing mobile number',
    detail: 'Telecom call forwarding — no new primary number.',
  },
  {
    title: 'Consumer + business',
    detail: 'One engine for individuals, professionals and businesses.',
  },
  {
    title: 'Live AI interaction',
    detail: 'Direct the AI during the call.',
  },
  {
    title: 'Persistent context',
    detail: 'Caller experiences, memory and post-call intelligence.',
  },
  {
    title: 'Beyond voice',
    detail: 'Voice · WhatsApp · Website AI · Workflows · Integrations.',
  },
  {
    title: 'Action layer',
    detail: 'Conversations become calendar events and workflows.',
  },
]

export const lifecycle = [
  'Answer',
  'Understand',
  'Personalize',
  'Interact',
  'Remember',
  'Act',
]

export const competitiveClosing =
  'The market solves communication in pieces. VEXU connects the experience end-to-end.'

export const competitiveClosingNote =
  'One AI engine spanning personal communication, business communication and the actions that follow.'
